import * as React from 'react';

import {OnboardingChecklist} from 'shells/onboarding-checklist/onboarding-checklist';

import type {GetInboxDashboardChecklist_inboxDashboardChecklist as InboxDashboardChecklist} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';
import {useDismissibleUserSetting} from '../../../util/hooks/use-dismissible-user-setting';

import {useOpenableModal} from '../../openable-modals';
import {ENGAGEMENT_BAR_ONBOARDING_MODAL} from '../../openable-modals/openable-modals';

import {getOnboardingChecklistItems} from './helpers';

// Needs to be same as constant in library\Nut\OnboardingWizards.php
const HAS_DISMISSED_CHECKLIST = 'has_dismissed_inbox_dashboard_checklist';

type Props = {
    inboxDashboardChecklist: InboxDashboardChecklist | null | undefined;
    checklistIsComplete: boolean;
    completedCount: number;
    totalCount: number;
    hasCollapsedButton?: boolean;
};

export function Checklist(props: Props) {
    const {shouldShow, onDismiss} = useDismissibleUserSetting(HAS_DISMISSED_CHECKLIST);

    const {onOpen: onOpenEngagementBarOnboardingModal} = useOpenableModal(
        ENGAGEMENT_BAR_ONBOARDING_MODAL
    );

    if (!shouldShow || !onDismiss || !props.inboxDashboardChecklist) {
        return null;
    }
    const inboxDashboardChecklist: InboxDashboardChecklist = props.inboxDashboardChecklist;

    const checklist = {
        __typename: inboxDashboardChecklist.__typename,
        percentComplete: inboxDashboardChecklist.percentComplete,
        items: getOnboardingChecklistItems(
            inboxDashboardChecklist.items,
            appHistory,
            onOpenEngagementBarOnboardingModal
        ),
    } as const;

    return (
        <OnboardingChecklist
            checklist={checklist}
            onClose={() => {
                onDismiss();
            }}
            checklistIsComplete={props.checklistIsComplete}
            completedCount={props.completedCount}
            totalCount={props.totalCount}
            history={appHistory}
            title='Explore Nutshell Engagement at your own pace'
            hasCollapsedButton={props.hasCollapsedButton}
        />
    );
}
